/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { AccordionFeatureCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { css } from "@panda/css";
import { VStack } from "@panda/jsx";

import { AccordionFeatureCard } from "./AccordionFeatureCard.molecule";

const styles = css({
	marginInline: "auto",
	maxWidth: "1400px",
	width: "100%",
	display: "flex",
	flexDirection: "column",
	gap: { base: "eds.dimension.12", sm: "eds.dimension.16" },
});

export const AccordionFeatureCardsSection = ({
	config,
	items,
}: AccordionFeatureCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(items?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.48">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<div className={styles}>
								{items.map((item, i) => (
									<AccordionFeatureCard key={item.title?.text || `accordion-feature-card-${i}`} index={i} {...item} />
								))}
							</div>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
